
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/types-of-rvs",
      function () {
        return require("private-next-pages/types-of-rvs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/types-of-rvs"])
      });
    }
  